module.exports = __webpack_public_path__ + "static/img/11.4e6d235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/11.png
// module id = ww1i
// module chunks = 0